/* eslint-disable jira/filename-case */
import {
	UFOExperience,
	ExperienceTypes,
	ExperiencePerformanceTypes,
	untilAll,
} from '@atlassian/ufo/ufo-experimental';

export const GlobalIssueCreateFromTopNav: UFOExperience = new UFOExperience(
	'global-issue-create-from-top-nav',
	{
		type: ExperienceTypes.Operation,
		performanceType: ExperiencePerformanceTypes.Custom,
		until: untilAll([{ category: 'global-issue-create.create-issue' }]),
	},
);
